import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { chevronDownIcon } from "../../../../assets/icons";
import { uniqueId } from "lodash";
import { ONE } from "../../../../constants";
import { NodeHandle } from "../../../../components/atoms";

const FIVE = 5;

const RenderAutoMapperObjectProperties = ({
  properties,
  paramToBeExpanded,
  handleExpandedParams,
  indent = ONE,
  target,
  position,
  nodeId,
}) =>
  !isEmpty(properties) &&
  properties.map((property) => {
    const isExpanded = paramToBeExpanded.includes(property.name);
    const isExpandable = !isEmpty(property.body);
    return (
      <div key={uniqueId(property.name)}>
        {property.type && (
          <NodeHandle
            key={property.name}
            nodeId={nodeId}
            handleId={property.level}
            position={position}
            target={target}
          />
        )}
        <div className="flex items-center">
          <div
            className={classNames("rounded-sm h-auto bg-slate-400 mr-1", {
              invisible: !isExpandable,
            })}
          >
            <img
              src={chevronDownIcon}
              alt="chevron Down"
              className={classNames("duration-300 cursor-pointer w-4", {
                "-rotate-90": !isExpanded,
                "opacity-10": isExpanded,
                "!cursor-not-allowed": isExpanded,
              })}
              onClick={() => {
                if (!paramToBeExpanded.includes(property.name) && !isExpanded)
                  handleExpandedParams(property.name);
              }}
            />
          </div>
          <div className="w-full flex justify-between">
            <div
              className=" font-medium text-[10px]"
              style={{ marginLeft: indent * FIVE }}
            >
              {property.name}
            </div>
            <div className="italic font-thin text-[10px] self-center">
              {property.type}
            </div>
          </div>
        </div>
        <div>
          {isExpanded && (
            <RenderAutoMapperObjectProperties
              properties={property.body}
              paramToBeExpanded={paramToBeExpanded}
              handleExpandedParams={handleExpandedParams}
              indent={indent + ONE}
              nodeId={nodeId}
              position={position}
              target={target}
            />
          )}
        </div>
      </div>
    );
  });

export default RenderAutoMapperObjectProperties;
